import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Link } from '@grandvisionhq/common';
import { Container } from '@grandvisionhq/elements';
import { BannerTooltip } from '../BannerTooltip/BannerTooltip.js';
import LazyPicture from '../LazyPicture/LazyPicture.js';
import Picture from '../Picture/Picture.js';

const ImageComponent = ({ image , mobileImage , useContainer =false , useLazyLoading =true , tooltip ,  })=>{
    if (!image) return null;
    const ContainerComponent = useContainer ? Container : React.Fragment;
    let imgSizes;
    if (useContainer) {
        // banner width is capped at 1370px when in a container
        imgSizes = {
            M: 768,
            L: 1024,
            XL: 1370,
            MAX: 1370
        };
    }
    return /*#__PURE__*/ React.createElement(ContainerComponent, null, useLazyLoading ? /*#__PURE__*/ React.createElement(LazyPicture, {
        mobileImage: mobileImage,
        image: image,
        imgSizes: imgSizes
    }) : /*#__PURE__*/ React.createElement(Picture, {
        mobileUrl: mobileImage === null || mobileImage === void 0 ? void 0 : mobileImage.url,
        url: image.url,
        alt: image.alt,
        width: image.dimensions.w,
        height: image.dimensions.h,
        imgSizes: imgSizes
    }), tooltip && /*#__PURE__*/ React.createElement(BannerTooltip, {
        className: "banner__tooltip",
        tooltip: tooltip
    }));
};
const Banner = (props)=>{
    const { link , image  } = props;
    if (!image) {
        console.warn('Cannot render Banner: missing image');
        return null;
    }
    return /*#__PURE__*/ React.createElement("div", {
        className: "banner",
        "data-t": "banner"
    }, link ? /*#__PURE__*/ React.createElement(Link, {
        href: link.url,
        target: link.target,
        className: "banner__link",
        labelAccessibility: link.label ? link.label : link.alt
    }, link.label && /*#__PURE__*/ React.createElement("span", {
        className: "banner__link-text"
    }, link.label), /*#__PURE__*/ React.createElement(ImageComponent, swcHelpers.extends({}, props))) : /*#__PURE__*/ React.createElement(ImageComponent, swcHelpers.extends({}, props)));
};

export { Banner as default };
//# sourceMappingURL=Banner.js.map
